<div
  class="p-2 ml-2 text-xs rounded-lg shadow-lg ngx-toastr w-fit"
  [ngClass]="{
    'bg-project-2000 text-project-200': !userSaved,
    'bg-project-2100 text-project-200': userSaved
  }"
>
  <button
    class="absolute p-1 top-1 right-1 text-project-200 hover:text-red-500"
    (click)="onClose()"
    aria-label="Close"
  >
    ✕
  </button>
  <span>{{ title }}</span>

  <div
    *ngIf="userSaved; else userListContent"
    class="flex justify-center flex-nowrap"
  >
    <div
      class="items-center flex-shrink-0 p-2 m-1 mr-4 text-xs bg-white rounded shadow-md text-project-2100 text-inherit whitespace-nowrap"
    >
      <span>User </span>
      <span class="font-bold pr-0.5">{{ userSaved }}</span>
      <span class="text-project-2100">has saved changes</span>
    </div>
  </div>

  <ng-template #userListContent>
    <mat-list>
      <div class="flex flex-nowrap">
        <ng-container *ngFor="let user of userList">
          <div
            class="items-center flex-shrink-0 p-2 m-1 text-xs bg-white rounded shadow-md text-project-2000 text-inherit whitespace-nowrap"
          >
            <span class="font-bold pr-0.5">{{ user.username }}</span>
            <span
              [ngClass]="{
                'text-project-2100': user.action === userActionMap['editing'],
                'brightness-75': user.action !== userActionMap['editing']
              }"
            >
              is {{ userActionMap[user.action] }}
            </span>
          </div>
        </ng-container>
      </div>
    </mat-list>
  </ng-template>
</div>
